module.exports = __webpack_public_path__ + "static/media/unico.a9ce6ca2.png";